
import React from 'react';
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogAction } from "@/components/ui/alert-dialog";
import { CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

interface SuccessDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  emailSent?: boolean;
  emailError?: string | null;
  isSendingEmail?: boolean;
  onRetryEmail?: () => void;
}

export const SuccessDialog = ({ 
  open, 
  onOpenChange, 
  emailSent = false, 
  emailError = null, 
  isSendingEmail = false, 
  onRetryEmail 
}: SuccessDialogProps) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="sm:max-w-[500px] bg-gradient-to-br from-green-50 to-green-100 border-2 border-green-300">
        <AlertDialogHeader className="text-center">
          <div className="flex justify-center mb-4">
            <div className="bg-green-500 rounded-full p-4 animate-pulse">
              <CheckCircle className="h-12 w-12 text-white" />
            </div>
          </div>
          <AlertDialogTitle className="text-2xl font-bold text-green-700 mb-2 text-center">Շնորհակալություն</AlertDialogTitle>
          <AlertDialogDescription className="text-lg text-green-800 leading-relaxed space-y-2">
            <p className="font-semibold">Սիրելի դիմորդ,</p>
            <p>Ձեր հայտը ուղարկվել է։</p>
            <p>Շուտով մեր մասնագետները կապ կհաստատեն Ձեզ հետ։</p>
            <p className="font-medium mt-4">Շնորհակալություն դիմելու համար։</p>
            
            {emailSent && (
              <div className="mt-4 p-3 bg-green-200/50 border border-green-300 rounded-lg">
                <p className="text-green-700 text-sm font-medium">
                  ✅ Հաստատման նամակն ուղարկվել է Ձեր էլ. փոստին
                </p>
              </div>
            )}
            
            {emailError && (
              <div className="mt-4 p-3 bg-red-200/50 border border-red-300 rounded-lg">
                <p className="text-red-700 text-sm font-medium mb-2">
                  ❌ {emailError}
                </p>
                {onRetryEmail && (
                  <Button 
                    onClick={onRetryEmail}
                    disabled={isSendingEmail}
                    size="sm"
                    variant="outline"
                    className="text-xs border-red-300 text-red-700 hover:bg-red-50"
                  >
                    {isSendingEmail ? 'Ուղարկվում է...' : 'Կրկին փորձել'}
                  </Button>
                )}
              </div>
            )}
            
            {isSendingEmail && !emailSent && !emailError && (
              <div className="mt-4 p-3 bg-blue-200/50 border border-blue-300 rounded-lg">
                <p className="text-blue-700 text-sm font-medium">
                  📧 Հաստատման նամակն ուղարկվում է...
                </p>
              </div>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="justify-center">
          <AlertDialogAction 
            onClick={() => onOpenChange(false)} 
            className="bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white px-8 py-2 rounded-lg font-semibold"
          >
            Շարունակել
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
